// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u71y","top":"styles_top__3PdFP","left":"styles_left__U87E9","description":"styles_description__61o0j"};